import { useCallback } from "react";
import { useTranslation } from "shared/i18n/useTranslation";
import { useToast } from "shared/toast/useToast";
import { FetchJsonError } from "../fetch/fetchJson";
import { useUnhandledRejectionHandler } from "./useUnhandledRejectionHandler";

export function useDefaultUnhandledRejectionHandler() {
  const { error } = useToast();
  const { translate } = useTranslation();
  const callback = useCallback(
    (event: PromiseRejectionEvent) => {
      if (
        (event?.reason instanceof FetchJsonError && event?.reason.aborted) ||
        event?.reason?.name === "AbortError"
      ) {
        //Do nothing because component is unmounted and fetch is cancelled
        event.preventDefault();
        return;
      }

      if (
        event?.reason instanceof FetchJsonError &&
        event?.reason.aborted === false
      ) {
        event.preventDefault();
        error(translate("__SorrySomethingBadHappenedTryAgain"));
        return;
      }
    },
    [error, translate]
  );
  useUnhandledRejectionHandler(callback);
}
